import { PropertyTypes } from "epsm-api-types";
import { formatValue } from "@/components/widgets/helpers/FormattingHelpers";

export const isToday = (date: Date): boolean => {
	if (Number.isNaN(date.getTime())) return false;

	return (
		new Date(formatValue(date, PropertyTypes.DATE)).toDateString() ===
		new Date().toDateString()
	);
};
